import { render, staticRenderFns } from "./ManageFilterGroupsModal.vue?vue&type=template&id=e806ab18&scoped=true"
import script from "./ManageFilterGroupsModal.vue?vue&type=script&lang=js"
export * from "./ManageFilterGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageFilterGroupsModal.vue?vue&type=style&index=0&id=e806ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806ab18",
  null
  
)

export default component.exports